<script setup lang="ts">
import type { CartStepperControl } from "../cartBoxControls";

defineProps<{ control: CartStepperControl }>();
</script>

<template
	>{{ control.label }}</template
>
